import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  searchCases,
  createTask,
  getCaseTasks,
  updateTask,
  deleteTask,
  taskDocumentDelete,
  sendTaskEmail,
} from "../../../api/caseTask_api";

export const searchCasesAction = createAsyncThunk(
  "caseTask/searchCasesAction",
  async ({ searchValue, userId, orgId }, { rejectWithValue }) => {
    try {
      const data = await searchCases(searchValue, userId, orgId);
      return data;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  },
);

export const createTaskAction = createAsyncThunk(
  "caseTask/createTaskAction",
  async (formData, { rejectWithValue }) => {
    try {

      const data = await createTask(formData);

      return data;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  },
);

export const getCaseTasksAction = createAsyncThunk(
  "caseTask/getCaseTasksAction",
  async ({ userId, orgID }, { rejectWithValue }) => {
    try {
      const data = await getCaseTasks(userId, orgID);
      return data;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  },
);

export const updateTaskAction = createAsyncThunk(
  "caseTask/updateTaskAction",
  async ({ taskNumber, formData }, { rejectWithValue }) => {
    try {
      const data = await updateTask(taskNumber, formData);
      return data;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  },
);

export const deleteTaskAction = createAsyncThunk(
  "caseTask/deleteTaskAction",
  async (taskNumber, { rejectWithValue }) => {
    try {
      await deleteTask(taskNumber);
      return taskNumber;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  },
);

export const deleteDocumentAction = createAsyncThunk(
  "caseTask/deleteDocument",
  async ({ TaskDocId, userId }, { rejectWithValue }) => {
    try {
      const response = await taskDocumentDelete({ TaskDocId, userId });
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to delete document");
    }
  },
);

export const sendTaskEmailAction = createAsyncThunk(
  "caseTask/sendTaskEmailAction",
  async ({ taskId, includeAdditional }, { rejectWithValue }) => {
    try {
      const response = await sendTaskEmail(taskId, includeAdditional);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to send email");
    }
  },
);
